import { Link } from 'react-router-dom';

export default function RefonteSiteWebParis() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-br from-teal-500 to-orange-500 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-xl">DC</span>
            </div>
            <span className="text-xl font-bold text-gray-900">DigiCreate</span>
          </Link>
          <a href="tel:+33123456789" className="bg-teal-500 text-white px-6 py-3 rounded-full font-semibold hover:bg-teal-600 transition-all hover:scale-105 flex items-center gap-2 whitespace-nowrap">
            <i className="ri-phone-line text-lg"></i>
            Appeler
          </a>
        </div>
      </header>

      {/* Hero Section */}
      <section className="pt-32 pb-20 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-black text-gray-900 mb-6 leading-tight">
            Refonte de Site Web Professionnel à Paris
          </h1>
          <p className="text-xl text-gray-600 mb-8 leading-relaxed">
            Spécialiste en <strong>modernisation de site internet</strong> et <strong>refonte web responsive</strong> à Paris. Nous transformons votre site obsolète en plateforme moderne, rapide et performante qui génère des résultats.
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <a href="https://wa.me/33123456789?text=Bonjour,%20je%20souhaite%20obtenir%20des%20informations%20sur%20la%20refonte%20de%20mon%20site%20web" className="bg-teal-500 text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-teal-600 transition-all hover:scale-105 whitespace-nowrap">
              Audit Gratuit de Mon Site
            </a>
            <Link to="/" className="bg-gray-100 text-gray-900 px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-200 transition-all whitespace-nowrap">
              Voir nos Refontes
            </Link>
          </div>
        </div>
      </section>

      {/* Why Refonte Section */}
      <section className="py-20 px-6 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl font-black text-gray-900 mb-4 text-center">Pourquoi Refaire Son Site Web ?</h2>
          <p className="text-lg text-gray-600 mb-12 text-center max-w-3xl mx-auto">
            Votre site actuel ne répond plus aux standards modernes ? Une <strong>refonte de site internet</strong> s'impose pour rester compétitif.
          </p>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-lg transition-all">
              <div className="w-14 h-14 bg-red-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-speed-up-line text-3xl text-red-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Performance Lente</h3>
              <p className="text-gray-600 leading-relaxed">
                Un site lent fait fuir vos visiteurs. Nous optimisons la <strong>vitesse de chargement</strong> et les Core Web Vitals pour améliorer votre référencement Google et l'expérience utilisateur.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-lg transition-all">
              <div className="w-14 h-14 bg-orange-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-smartphone-line text-3xl text-orange-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Non Responsive</h3>
              <p className="text-gray-600 leading-relaxed">
                Plus de 60% du trafic vient du mobile. Nous créons un <strong>design responsive</strong> parfaitement adapté à tous les écrans pour ne perdre aucun client potentiel.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-lg transition-all">
              <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-search-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Mauvais SEO</h3>
              <p className="text-gray-600 leading-relaxed">
                Invisible sur Google ? Nous intégrons les meilleures pratiques de <strong>référencement naturel</strong> pour améliorer votre positionnement et générer du trafic qualifié.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl font-black text-gray-900 mb-4 text-center">Notre Offre de Refonte Web</h2>
          <p className="text-lg text-gray-600 mb-12 text-center max-w-3xl mx-auto">
            Une <strong>refonte complète</strong> qui transforme votre présence en ligne.
          </p>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-gradient-to-br from-teal-50 to-orange-50 p-8 rounded-2xl">
              <div className="w-14 h-14 bg-white rounded-xl flex items-center justify-center mb-6 shadow-sm">
                <i className="ri-layout-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Refonte Design UX/UI</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Modernisation complète de votre <strong>interface utilisateur</strong> avec un design contemporain, une navigation intuitive et une expérience optimisée pour la conversion.
              </p>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-500 mt-1"></i>
                  <span>Audit UX de l'existant</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-500 mt-1"></i>
                  <span>Maquettes modernes et responsive</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-500 mt-1"></i>
                  <span>Parcours utilisateur optimisé</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-500 mt-1"></i>
                  <span>Tests A/B et optimisation</span>
                </li>
              </ul>
            </div>

            <div className="bg-gradient-to-br from-orange-50 to-teal-50 p-8 rounded-2xl">
              <div className="w-14 h-14 bg-white rounded-xl flex items-center justify-center mb-6 shadow-sm">
                <i className="ri-code-box-line text-3xl text-orange-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Refonte Technique SEO</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Migration vers des <strong>technologies modernes</strong> avec optimisation technique complète pour la performance, la sécurité et le référencement naturel.
              </p>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-orange-500 mt-1"></i>
                  <span>Migration sans perte de SEO</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-orange-500 mt-1"></i>
                  <span>Optimisation Core Web Vitals</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-orange-500 mt-1"></i>
                  <span>Sécurité renforcée (HTTPS, RGPD)</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-orange-500 mt-1"></i>
                  <span>Structure SEO optimisée</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 px-6 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl font-black text-gray-900 mb-4 text-center">Notre Méthodologie de Refonte</h2>
          <p className="text-lg text-gray-600 mb-12 text-center max-w-3xl mx-auto">
            Un processus structuré pour une <strong>refonte de site web réussie</strong> sans interruption de service.
          </p>

          <div className="grid md:grid-cols-5 gap-6">
            {[
              { icon: 'ri-file-search-line', title: 'Audit', desc: 'Analyse complète de votre site actuel' },
              { icon: 'ri-lightbulb-line', title: 'Stratégie', desc: 'Définition des objectifs et KPIs' },
              { icon: 'ri-pencil-ruler-2-line', title: 'Design', desc: 'Création des nouvelles maquettes' },
              { icon: 'ri-code-s-slash-line', title: 'Développement', desc: 'Intégration et migration' },
              { icon: 'ri-rocket-line', title: 'Lancement', desc: 'Mise en ligne et suivi' }
            ].map((step, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-orange-500 rounded-2xl flex items-center justify-center mx-auto mb-4">
                  <i className={`${step.icon} text-3xl text-white`}></i>
                </div>
                <div className="text-sm font-bold text-teal-500 mb-2">Étape {index + 1}</div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{step.title}</h3>
                <p className="text-gray-600 text-sm">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-6 bg-gradient-to-br from-teal-500 to-orange-500">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h2 className="text-4xl md:text-5xl font-black mb-6">Modernisez Votre Site Web Maintenant</h2>
          <p className="text-xl mb-8 opacity-95">
            Obtenez un audit gratuit de votre site actuel et découvrez comment nous pouvons le transformer.
          </p>
          <a href="https://wa.me/33123456789?text=Bonjour,%20je%20souhaite%20obtenir%20un%20audit%20gratuit%20pour%20la%20refonte%20de%20mon%20site%20web" className="inline-block bg-white text-teal-600 px-10 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-all hover:scale-105 whitespace-nowrap">
            Demander un Audit Gratuit
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12 px-6">
        <div className="max-w-6xl mx-auto text-center">
          <p className="text-gray-400 mb-4">© 2025 DigiCreate - Agence de Refonte Web à Paris</p>
          <div className="flex justify-center gap-6">
            <Link to="/" className="text-gray-400 hover:text-white transition-colors">Accueil</Link>
            <a href="mailto:contact@digicreate.fr" className="text-gray-400 hover:text-white transition-colors">Contact</a>
          </div>
        </div>
      </footer>

      {/* WhatsApp Floating Button */}
      <a href="https://wa.me/33123456789?text=Bonjour,%20je%20souhaite%20obtenir%20des%20informations%20sur%20vos%20services%20digitaux" className="fixed bottom-6 right-6 z-50 w-16 h-16 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-all animate-bounce" aria-label="Contacter sur WhatsApp">
        <i className="ri-whatsapp-line text-3xl text-white"></i>
        <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full"></span>
      </a>
    </div>
  );
}
